import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import Footer from './components/Footer';
import LanguageSelector from './components/LanguageSelector';

const App: React.FC = () => {
  return (
    <Router>
      <div className="u-app">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </main>
        <LanguageSelector />
      </div>
      <Footer />
    </Router>
  );
};

export default App;
